import React, { useState, useEffect } from 'react';
import { message, Spin, Tooltip, Steps, Popconfirm, Skeleton, Modal, Image, } from 'components/shared/AntComponent';
import { Button, Form, Select, Input, InputNumber, TimePicker, DatePicker, TextArea, Radio } from 'components/shared/FormComponent';
import { DeleteFilled, DownCircleFilled, DownSquareOutlined, LoadingOutlined, SyncOutlined, ArrowLeftOutlined } from 'components/shared/AntIcons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getQuestionPaper, getQuestionPaperDetail, getQuestionTemplate } from 'services/store/actions/questionPaperAction';
import { addExam, autoGenerateQuestion, generateAutoQuestion, getDeptQuestions, getExamDetail, sendMailtoAll } from 'services/store/actions/examAction';
import dayjs from 'dayjs';
import { getAllApplicant, getApplicantDetails, getApplicantType } from 'services/store/actions/candidateAction';
import { getAccountDetail, getAccountList } from 'services/store/actions/accountAction';
import AddSlotScreen from '../sub-screens/AddSlotScreen';
import { EditIcon, SendMailIcon, DisableSendMailIcon, EyeIcon } from 'assets/icons/CustomIcons';
import DelImg from 'assets/img/del.png';


const BackupUpdateExam: React.FC = () => {
    const history = useNavigate();
    const [form] = Form.useForm();
    const location = useLocation();
    const dispatch = useDispatch();
    const { questionpaperData, loading: loadingQuestions, loading11, templateInfo, paperInfo, loading4: paperLoading } = useSelector((state: any) => state.questionpaper);
    const { candidateData, loading: loadingCandidates, applicantInfo, loading15, appTypeInfo, loading17, loading18, applicantListInfo } = useSelector((state: any) => state.candidate);
    const { success1, loading1, error1, examDetailInfo, loading4, deptQuesInfo, loading12, loading15: autoLoading, autoQuesInfo, loading16, newAutoQuesInfo,
        loading13, success13, error13
    } = useSelector((state: any) => state.exam);
    const { invAccountInfo, loading3 } = useSelector((state: any) => state.account);
    const [isAutomate, setIsAutomate] = useState(false);
    const [questionCount, setQuestionCount] = useState(0);
    const [isNegativemark, setIsNegativemark] = useState(false);
    const [totalMark, setTotalMark] = useState(0);
    const [current, setCurrent] = useState(0);
    const [slots, setSlots]: any = useState([]);
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success1 : false;
    const [showErrmsg, setShowErrMsg] = useState(false);
    const errormsg = showErrmsg ? error1 : false;
    const [dept, setDept]: any = useState(null);
    const userID = localStorage.getItem('userid');
    const [isPastDate, setIsPastDate] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [autoPapers, setAutoPapers]: any = useState(null);
    const [duration, setDuration] = useState(0);
    const [rowData, setRowData]: any = useState(null);
    const [slotID, setSlotID] = useState(0);
    const [openMailModal, setOpenMailModal] = useState(false);
    const [showSuccessmsg1, setShowSuccessmsg1] = useState(false);
    const successmsg1 = showSuccessmsg1 ? success13 : false;
    const [showErrormsg1, setShowErrormsg1] = useState(false);
    const errormsg1 = showErrormsg1 ? error13 : false;
    const [openDangerModal, setOpenDangerModal] = useState(false);
    const [templateName, setTemplateName] = useState('');
    const [isRetakeExam, setIsRetakeExam] = useState(false);
    const [expandedSlots, setExpandedSlots] = useState(new Set([0]));
    const [slotIndex, setSlotIndex]: any = useState(null);
    const [tempOpt, setTempOpt]: any = useState([]);
    const [quesModal, setQuesModal] = useState(false);
    const [quesData, setQuesData]: any = useState(null);
    const [expandVal, setExpandVal]: any = useState([]);

    const handleOpenQuesModal = (id: any) => {
        setQuesModal(true);
        getquesPaper(id);
        setQuesData(null);
    }
    const onChange = (value: number) => {
        console.log('onChange:', value);
        setCurrent(value);
    };
    useEffect(() => {
        if (paperInfo?.data) {
            const value = paperInfo?.data?.[0]?.qpQuestions;
            setQuesData(value);

        }
    }, [paperInfo?.data])

    const handleCloseQuesModal = () => {
        setQuesModal(false);
    }

    const templateOptions = !loading11 && templateInfo?.data?.map((item: any) => {
        return {
            value: item?.quesTemplateID,
            label: item?.quesTemplateName
        }
    }) || [];

    const accOptions: any = !loading3 && invAccountInfo?.data?.map((acc: any) => {
        return {
            label: acc?.accountName,
            value: acc.id?.toString(),
            key: acc.id,
        };
    }) || [];

    useEffect(() => {
        if (!loading16 && newAutoQuesInfo?.status === "success") {
            setAutoPapers(newAutoQuesInfo)
        } else {
            setAutoPapers(null);
        }
    }, [newAutoQuesInfo, loading16]);

    const handleShowSlot = () => {
        setShowAdd(true);
        setRowData(null);
        setSlotIndex(null);
        const temp = form.getFieldValue('questionTemplate');
        const opt = templateOptions?.filter((item: any) => temp?.includes(item.value))?.map((item: any) => ({
            value: item.value,
            label: item.label
        })) || [];
        setTempOpt(opt);

    }
    const closeSlot = () => {
        setShowAdd(false);
    }

    const submitForm = async () => {
        try {
            const val = await form.validateFields();
            const inputJson = {
                "ExamID": location?.state?.id || 0,
                "ExamName": val.examName || "",
                "ExamDescription": val.description || "",
                "QuesTemplateID": val.questionTemplate?.toString() || "",
                "QuesTemplateName": val.questionTemplate ? templateOptions?.filter((item: any) => val?.questionTemplate?.includes(item.value))
                    ?.map((o: any) => o.label)?.join(",") : "",
                "ExamDuration": val.duration?.toString(),
                "ExamDate": val?.examDate ? dayjs(val.examDate).format('YYYY-MM-DD') : '',
                "TotalMarks": val?.totalMark || 0,
                "NegativeMarks": val?.negativeMark || 0,
                "IsAutoSubmit": true,
                "IsAllowRetake": val?.retakeExam || true,
                "MaxAttempts": val?.maxAttempts ? Number(val?.maxAttempts) : 0,
                "IsShowResultAFExam": val?.showResult || true,
                "AccountName": val?.college ? accOptions?.find((item: any) => item.value === val?.college)?.label : "",
                "AccountId": val?.college ? Number(val?.college) : 0,
                "TenantId": Number(localStorage.getItem('tenantID')),
                "ExamSlots": slots || null,
            };
            dispatch(addExam(inputJson) as any);
            setShowSuccessmsg(true);
            setShowErrMsg(true);
        }
        catch (errorInfo) {
            console.log('Failed:', errorInfo);
        }
    };

    useEffect(() => {
        if (successmsg) {
            if (location?.state?.id === 0) {
                message.success('Exam created successfully');
            } else {
                message.success('Exam updated successfully');
            }
            history('/exam');
            setShowSuccessmsg(false);
        }
        if (errormsg) {
            if (errormsg?.message) {
                message?.error(errormsg?.message);
            } else {
                message.error("Exam couldn't be created");
            }
            setShowErrMsg(false);
        }
    }, [successmsg, errormsg]);

    const goToPreviousScreen = () => {
        history('/exam');
    };
    const getquesPaper = (id: any) => {
        const ids = id + "/" + Number(localStorage.getItem('tenantID'));
        dispatch(getQuestionPaperDetail(ids) as any);
    };
    const getDetail = () => {
        const id = location?.state?.id + "/" + Number(localStorage.getItem('tenantID'));
        dispatch(getExamDetail(id) as any);
    };

    useEffect(() => {
        if (location?.state?.id !== 0) {
            getDetail();
        }
    }, [location?.state?.id]);

    const disablePastDates = (current: dayjs.Dayjs) => {
        // Disable dates before today
        return current && current < dayjs().startOf('day');
    };

    const handleAutoChange = (e: any) => {
        setIsAutomate(e.target.value);
        setTotalMark(0);
        setQuestionCount(0);
    }


    const handleDurationChange = (e: any) => {
        setDuration(e);
        if (slots && slots.length > 0) {
            const updatedSlots = slots.map((slot: any) => {
                const startTime = dayjs(slot?.slotStartTime?.format('HH:mm a'), 'HH:mm a');
                if (!startTime?.isValid()) {
                    return slot; // Return the slot as is if the start time is invalid
                }

                const endTime = startTime.add(e, 'minute'); // e is the duration in minutes

                return {
                    ...slot,
                    slotEndTime: endTime, // Update the end time in HH:mm a format
                };
            });
        }
    }

    const loadData = () => {
        if (location?.state?.id == 0) {
            form.setFieldsValue({
                examTitle: "",
                examDate: null,
                description: '',
                totalQuestions: '',
                duration: '',
                questionPapers: null,
                associateCandidates: [],
                negativeMark: null,
                questionPaperA: "",
                "isNegativeMark": false,
                "automateQuestions": false,
                slots: slots,
                department: null,
                account: ""
            });
            setIsAutomate(false);
            setIsNegativemark(false);
            setQuestionCount(0);
            setTotalMark(0);
            setDept(null);
        } else {
            console.log("");
        }
    }

    const loadData1 = () => {
        if (examDetailInfo?.data && location?.state?.id !== 0) {
            const defaultValue = examDetailInfo?.data?.[0];
            setDuration(defaultValue?.examDuration);
            form.setFieldsValue({
                examName: defaultValue?.examName || "",
                examDate: defaultValue?.examDate ? dayjs(new Date(defaultValue?.examDate)) : null,
                duration: defaultValue?.examDuration ? Number(defaultValue?.examDuration) : null,
                college: defaultValue?.accountId?.toString() || null,
                totalMark: defaultValue?.totalMarks || null,
                negativeMark: defaultValue?.negativeMarks || 0,
                automateQuestions: true,
                showResult: defaultValue?.isShowResultAFExam || false,
                allowRetake: defaultValue?.isAllowRetake || false,
                maxAttempts: defaultValue?.maxAttempts || null,
                questionTemplate: defaultValue?.quesTemplateID ? defaultValue?.quesTemplateID?.split(',')?.map(Number) : null,
                description: defaultValue?.examDescription || "",
            });
            const slotJson = defaultValue?.examSlots?.map((value: any) => ({
                ExamSlotId: value?.examSlotId || 0,
                ExamID: defaultValue?.examID || 0,
                ExamSlotName: value.examSlotName || "",
                ExamStartTime: value.examStartTime || null,
                ExamEndTime: value.examEndTime || null,
                ExamDuration: defaultValue?.examDuration || null,
                IsAssoCondition: value.isAssoCondition || "",
                ConditionIDs: value.isAssoCondition === "gender" ? value?.conditionIDs?.split(',') : value?.conditionIDs?.split(',')?.map(Number) || "",
                ConditionName: value.isAssoCondition === "gender" ? value?.conditionName?.split(',') : value?.conditionName?.split(',') || "",
                TotalCapacity: value.totalCapacity || "",
                Status: value.status || "active",
                TenantId: Number(localStorage.getItem('tenantID')),
                AccountId: Number(defaultValue?.accountId) || null,
                QuestionPaper: {
                    QuesPaperID: value?.questionPaper?.quesPaperID || 0,
                    QuesPaperName: value?.questionPaper?.quesPaperName || "",
                    QuesGenMode: "Auto",
                    ExamID: defaultValue?.examID || 0,
                    ExamName: defaultValue?.examName || "",
                    SlotID: value?.examSlotId || 0,
                    SlotName: value.examSlotName || "",
                    NoOfQuestions: defaultValue?.totalMarks,
                    TotalMarks: defaultValue?.totalMarks,
                    Notes: value?.questionPaper?.notes || "",
                    TenantId: Number(localStorage.getItem('tenantID')),
                    EasyPercent: value?.questionPaper?.easyPercent,
                    MediumPercent: value?.questionPaper?.mediumPercent,
                    HardPercent: value?.questionPaper?.hardPercent,
                    IsCombinedTemplate: true,
                    Status: "Active",
                    QpSections: value?.questionPaper?.qpSections?.map((item: any) => ({
                        QpSectionID: item?.qpSectionID || 0,
                        QuesPaperID: item?.quesPaperID || 0,
                        QpSectionName: item.qpSectionName || "",
                        IsAssoCondition: item.isAssoCondition || "",
                        ConditionName: item.conditionName?.toString() || "",
                        QuesTemplateID: item.quesTemplateID?.toString() || "",
                        QuesTemplateName: item.quesTemplateName || "",
                        TenantId: Number(localStorage.getItem('tenantID')),
                    })) || null
                }
            }))
            setSlots(slotJson);
        }
        // setIsLoaded(true);
    }
    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        if (examDetailInfo?.data && location?.state?.id !== 0) {
            loadData1();
        }
    }, [examDetailInfo?.data]);


    const callbackFunc = (val: any) => {
        if (rowData) {
            //update row based on slotIndex variable
            setSlots((prevSlots: any) =>
                prevSlots.map((slot: any, idx: number) =>
                    idx === slotIndex ? val : slot
                )
            );
        } else {
            setSlots((prevSlots: any) => [...prevSlots, val]);
        }
        closeSlot();
    }
    const handleEdit = (val: any, index: number) => {
        console.log("Valllll", val);
        setRowData(val);

        setSlotIndex(index);
        const temp = form.getFieldValue('questionTemplate');
        const opt = templateOptions?.filter((item: any) => temp?.includes(item.value))?.map((item: any) => ({
            value: item.value,
            label: item.label
        })) || [];
        setTempOpt(opt);
        setShowAdd(true);
    }

    const sendEmailtoAll = () => {
        const inputJson = {
            "examid": location?.state?.id || "0",
            "slotid": slotID || 0,
            "email": "",
            "email_resend_flag": false
        }
        dispatch(sendMailtoAll(inputJson) as any);
        setShowSuccessmsg1(true);
        setShowErrormsg1(true);
    }

    const handleOpenMail = () => {
        setOpenMailModal(true);
    }

    const handleClose = () => {
        setOpenMailModal(false);
    }
    const handleOpenDanger = () => {
        setOpenDangerModal(true);
    }
    const handleCancel1 = () => {
        setOpenDangerModal(false);
    }
    const resendEmail = () => {
        const inputJson = {
            "examid": location?.state?.id || "",
            "slotid": slotID || 0,
            "email": "",
            "email_resend_flag": true
        }
        dispatch(sendMailtoAll(inputJson) as any);
        setShowSuccessmsg1(true);
        setShowErrormsg1(true);
    }

    function getTemplates() {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getQuestionTemplate(id) as any);
    }

    useEffect(() => {
        getTemplates();
    }, []);
    function getAccountInfo() {
        const id = 0 + "/" + Number(localStorage.getItem('tenantID'));
        dispatch(getAccountDetail(id) as any);
    }

    useEffect(() => {
        getAccountInfo();
    }, []);

    const handleRetakeChange = (e: any) => {
        setIsRetakeExam(e.target.value);
    }
    const handleRemoveSlot = (index: number) => {
        const updatedSlots = [...slots];  // Create a copy of the slots array
        updatedSlots.splice(index, 1);    // Remove the slot at the specified index
        setSlots(updatedSlots);           // Update the state with the new slots array
    };

    const handleExpand = (id: string) => {
        let myArray = expandVal;
        const valueExists = myArray.includes(id);
        if (!valueExists) {
            myArray = [...myArray, id];
        } else {
            if (myArray.includes(id)) {
                myArray = expandVal.filter((item: any) => item != id);
            }
        }
        setExpandVal(myArray);
    };

    return (
        <div className="my-3 children-container">
            <div className="px-0 ">
                <div className="row m-0 page-header">
                    <h5 className="my-auto col text-start ps-2 text-secondary fw-bold">{location?.state?.id === 0 ? 'Create Exam' : 'Update Exam'}</h5>
                    <div className="ms-auto col-md-8 text-end my-auto pe-2">
                        <Button type="primary" className="col-auto ms-2 btn-back" onClick={goToPreviousScreen}>
                            Back
                        </Button>
                    </div>
                </div>
            </div>
            <Spin spinning={loading4 || loadingQuestions}>
                <div className="body-content mx-0 mt-2 row">
                    <div className="col-md-12 px-2">
                        <Form style={{ display: showAdd ? "none" : "block" }} form={form} layout="vertical" preserve={false} className="bg-white p-2">
                            <div className='row mx-0 '>
                                <div className="px-2 py-3 form-padding">
                                    <div className="d-flex m-0 flex-wrap">
                                        <Form.Item className="col-md-6 px-2" label="Exam Title" name="examName"
                                            normalize={(value) =>
                                                value ? value.charAt(0).toUpperCase() + value.slice(1) : ''
                                            }
                                            rules={[{ required: true, message: 'This field is required' }]}>
                                            <Input disabled={isPastDate} />
                                        </Form.Item>
                                        <Form.Item className="col-md-2 col-lg-2 px-2" label="Date of Exam" name="examDate" rules={[{ required: true, message: 'This field is required' }]}>
                                            <DatePicker className="w-100" format="DD-MM-YYYY" disabledDate={disablePastDates} disabled={isPastDate} />
                                        </Form.Item>
                                        <Form.Item className="col-md-2 col-lg-2 px-2" label="Duration (In Minutes)" name="duration" rules={[{ required: true, message: 'This field is required' }]}>
                                            <InputNumber className="w-100" maxLength={3} onChange={(e) => handleDurationChange(e)} disabled={isPastDate} />
                                        </Form.Item>
                                        <Form.Item label="Select College" name="college" className="col-md-2 px-2" rules={[{ message: "This field is required", required: true }]}>
                                            <Select options={accOptions} />
                                        </Form.Item>
                                    </div>
                                    <div className="row m-0">
                                        <Form.Item className="col-md-2 col-lg-2 px-2" label="Total Mark" name="totalMark" rules={[{ required: true, message: 'This field is required' }]}>
                                            <InputNumber className="w-100" maxLength={3} disabled={isPastDate} />
                                        </Form.Item>
                                        <Form.Item className="col-md-2 col-lg-2 px-2" label="Negative Mark" name="negativeMark" rules={[{ required: true, message: 'This field is required' }]}>
                                            <InputNumber className="w-100" maxLength={3} disabled={isPastDate} />
                                        </Form.Item>
                                        <Form.Item className="col-md-2 col-lg-2 px-2" label="Automate Questions" name="automateQuestions" rules={[{ required: true, message: 'This field is required' }]}>
                                            <Radio.Group className='ms-1' onChange={(e) => handleAutoChange(e)} disabled>
                                                <Radio value={true} >Yes </Radio>
                                                <Radio value={false} >No</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        <Form.Item className="col-md-2 col-lg-2 px-2" label="Show results after submission" name="showResult" rules={[{ required: true, message: 'This field is required' }]}>
                                            <Radio.Group className='ms-1' disabled={isPastDate}>
                                                <Radio value={true} >Yes </Radio>
                                                <Radio value={false} >No</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        <Form.Item className="col-md-2 col-lg-2 px-2" label="Allow retake exam" name="allowRetake" rules={[{ required: true, message: 'This field is required' }]}>
                                            <Radio.Group className='ms-1' onChange={(e) => handleRetakeChange(e)} disabled={isPastDate}>
                                                <Radio value={true} >Yes </Radio>
                                                <Radio value={false} >No</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        {isRetakeExam ?
                                            <Form.Item className="col-md-2 col-lg-2 px-2" label="Max. Attempts" name="maxAttempts" rules={[{ required: true, message: 'This field is required' }]}>
                                                <Input />
                                            </Form.Item> : ""}
                                    </div>
                                    <div className="row m-0">
                                        <Form.Item label="Select Question Paper Template" name="questionTemplate" className="col px-2" rules={[{ message: "This field is required", required: true }]}>
                                            <Select options={templateOptions} mode="multiple" />
                                        </Form.Item>
                                    </div>
                                    <Form.Item className={`col-md-12 px-2 desc-form`} label="Description" name="description"
                                        normalize={(value) =>
                                            value ? value.charAt(0).toUpperCase() + value.slice(1) : ''
                                        }>
                                        <TextArea rows={2} disabled={isPastDate} />
                                    </Form.Item>
                                </div>
                            </div>
                        </Form>
                        <div className="bg-white p-3">
                            <div className="d-flex py-2 page-header">
                                <h6 className="fw-bold my-auto">{showAdd ? rowData ? "Update Slot" : "Create Slot" : "Slot Details"}</h6>
                                <div className="col-md-8 ms-auto text-end">
                                    {showAdd ? <div>
                                        <Button type="primary" className="col-auto rounded-circle fs-20" icon={<ArrowLeftOutlined className='fs-20 fw-bold' />} onClick={closeSlot}></Button>
                                    </div> :
                                        <Tooltip title={slots?.length >= 3
                                            ? "You have exceeded the maximum slot limit"
                                            : !duration
                                                ? "Please select duration"
                                                : ""}>
                                            <Button type="primary" onClick={() => handleShowSlot()} disabled={slots?.length == 4 || !duration ? true : false}>Add Slot</Button>
                                        </Tooltip>}
                                </div>
                            </div>
                            {showAdd || slots?.length != 0 ? "" :
                                <div className="text-danger fs-14">
                                    Note: Duration, College, Specialisation must be filled out to create new slot
                                </div>}
                            {showAdd ? <AddSlotScreen
                                totalMark={form.getFieldValue("totalMark")}
                                isPastDate={isPastDate} rowData={rowData}
                                slots={slots} duration={duration} tempOptions={tempOpt}
                                callbackFunc={callbackFunc}
                                college={form.getFieldValue("college")} examName={form.getFieldValue('examName')} /> : <>
                                {slots?.length == 0 ?
                                    <div className="bg-light p-5 mb-3 text-muted text-center">
                                        No slot associated
                                    </div> : <div>

                                        {slots?.map((item: any, index: number) => {
                                            const count = Number(index) + 1;
                                            return (
                                                <div key={index} className="mb-3 bg-light border p-3 w-100 ">
                                                    <div className="d-flex flex-wrap">
                                                        <div className='col-md-2'>
                                                            <h6 className='fs-15 fw-bold'>Slot Name</h6>
                                                            <span>{item.ExamSlotName || "--"}</span>
                                                        </div>
                                                        <div className='col-md-1'>
                                                            <h6 className='fs-15 fw-bold'>Start Time</h6>
                                                            <span>{item?.ExamStartTime ? item?.ExamStartTime : '--'}</span>
                                                        </div>
                                                        <div className='col-md-1'>
                                                            <h6 className='fs-15 fw-bold'>End Time</h6>
                                                            <span>{item?.ExamEndTime ? item?.ExamEndTime : '--'}</span>
                                                        </div>
                                                        <div className='col-md-1'>
                                                            <h6 className='fs-15 fw-bold'>Capacity</h6>
                                                            <span>{item?.TotalCapacity || '--'}</span>
                                                        </div>
                                                        <div className='col-md-2 '>
                                                            <h6 className='fs-15 fw-bold'>Status</h6>
                                                            <span className={`${item.Status?.toLowerCase() == "active" ? 'text-success fw-bold' : !item.isActive ? 'text-danger fw-bold' : 'text-dark'} text-capitalize`}>{item?.Status}</span>
                                                        </div>
                                                        <div className='col-md-2'>
                                                            <h6 className="fs-15 fw-bold">Is Question paper associated?

                                                            </h6>
                                                            <span className={`${item.QuestionPaper?.QpSections?.length > 0 ? 'text-success fw-bold' : !item.isActive ? 'text-danger fw-bold' : 'text-dark'}`}>{item.QuestionPaper?.QpSections?.length > 0 ? "Yes" : "No"}</span>
                                                        </div>
                                                        <div className='col-md-2'>
                                                            <h6 className="fs-15 fw-bold">View Question paper

                                                            </h6>
                                                            <span >{item.QuestionPaper?.QpSections?.length > 0 ? <span onClick={() => handleOpenQuesModal(item.QuestionPaper?.QuesPaperID)}><EyeIcon size={20} /> </span> : "--"}</span>
                                                        </div>

                                                        {isPastDate ? "" :
                                                            <div className="col-auto ms-auto d-flex align-items-center ">
                                                                <div className="pointer pb-2" onClick={() => handleEdit(item, index)}><EditIcon size={30} /></div>
                                                                <div className="pointer my-auto">
                                                                    <Popconfirm
                                                                        title="Delete Slot"
                                                                        description="Are you sure to delete this slot?"
                                                                        onConfirm={() => {
                                                                            handleRemoveSlot(index);

                                                                        }}
                                                                        okText="Yes"
                                                                        cancelText="No"
                                                                    >
                                                                        <span className="pt-2 fs-17">
                                                                            <DeleteFilled className="text-danger pointer" />
                                                                        </span>
                                                                    </Popconfirm>
                                                                </div>
                                                            </div>}
                                                    </div>

                                                </div>
                                            )
                                        })}</div>}
                            </>}

                        </div>
                    </div>


                </div>
                {isPastDate || showAdd ? "" :
                    <div className="row mx-0 mt-3 ps-3 pe-3 mb-3 page-footer-btns">
                        <Button type="default" className="col-auto ms-auto bg-secondary text-white rounded-0 me-2" onClick={goToPreviousScreen}>
                            Cancel
                        </Button>
                        <Button type="primary" className="col-auto me-0" disabled={showAdd || loading16} onClick={submitForm} loading={loading1}>
                            Save
                        </Button>
                    </div>
                }
            </Spin>
            <Modal title="Send Email" open={openMailModal} confirmLoading={loading13} onOk={() => sendEmailtoAll()} onCancel={handleClose} okText="Send mail">
                <h6>An exam link email will be sent to all applicants associated with this exam. Do you want to continue?</h6>
            </Modal>
            <Modal className="delete-modal" confirmLoading={loading13} open={openDangerModal} onCancel={handleCancel1} onOk={resendEmail} maskClosable={false} okText="Resend mail"
                cancelButtonProps={{
                    style: { backgroundColor: '#5a53b2', color: 'white' }
                }}
            >
                <div className="d-flex justify-content-center">
                    <Image src={DelImg} preview={false} height="90px" />
                </div>
                <h5 className="text-center mt-3 text-dark">Are you sure?</h5>
                <p className="fs-15 text-center">
                    An email has already been sent. Do you wish to send it again? This action will resend the exam link to all applicants associated with this exam.
                </p>
            </Modal>
            <Modal title="View Questions" open={quesModal} confirmLoading={paperLoading} onCancel={handleCloseQuesModal} maskClosable={false} footer={null} width={1200}>
                <>
                    <div className="mb-3 p-2 bg-light question-list-cont-modal custom-scrollbar row mx-0 overflow-auto">
                        {paperLoading ? (
                            <Skeleton active />
                        ) : (
                            <>
                                {quesData?.map((item: any, index: number) => {
                                    // counter1++;
                                    return (
                                        <div key={index} className=" d-flex mb-3 col-md-6">
                                            {/* <Checkbox
                                                className="mb-auto"
                                                defaultChecked={selectedVal1?.includes(item.id)}
                                                checked={selectedVal1?.includes(item.id)}
                                                onChange={handleCheckedModal(item.id, item)}
                                            ></Checkbox> */}
                                            <div className="question-cntr border ms-2 w-100">
                                                <div className="bg-lightPrimary d-flex p-2 align-items-start">
                                                    <div>
                                                        <span className="text-secondary fw-bold pe-3">( {index + 1} )</span>
                                                        <span className="author-name fw-bold text-gray pe-4">{item.questionText}</span>{' '}
                                                        {/* {item?.question_image ? <Image src={window.origin + "/api" + item.question_image} height={50} /> : ""} */}
                                                        {/* <span className="text-dark">System Admin</span> */}
                                                        <div className="me-2">
                                                            <div className="bg-primary fs-12 text-white rounded px-2 me-2 py-1 col-auto d-inline-block my-2">
                                                                {item.subjectName}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* <div className="ms-5 text-dark">
                                                    <span className=" fw-bold text-gray">Updated on: </span> <span className="text-dark">{date.format('DD-MM-YYYY HH:mm')}</span>
                                                </div> */}
                                                    <div className="ms-auto d-flex qus-opr">
                                                        <div className="pe-1 my-auto">
                                                            <DownCircleFilled
                                                                className={`${item.levelOfDifficulty?.toLowerCase() == 'easy' ? 'text-success bg-success' : item.levelOfDifficulty?.toLowerCase() == 'medium' ? 'text-warning bg-warning' : 'text-danger bg-danger'} rounded-circle`}
                                                            />
                                                        </div>
                                                        <div className="text-primary ms-1 mb-0 mt-1 pointer my-auto" onClick={() => handleExpand(item.questionId)}>
                                                            {expandVal?.includes(item.questionId) ? <DownSquareOutlined className="fs-17" rotate={-90} /> : <DownSquareOutlined className="fs-17" />}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`p-2 d-flex question-contn bg-white ${expandVal?.includes(item.questionId) ? 'incheight' : ''}`}>
                                                    <div className="ps-2 pe-4 w-100">
                                                        {/* <span className="question text-dark fs-16">{item.Mdquestions_name}</span> */}
                                                        <div className="row m-3">
                                                            {item.Mdquestions_type === "inputfield" || item.Mdquestions_type == "input" ? <div className="fw-bold fs-15">
                                                                <span className="text-success">
                                                                    {item.answer}
                                                                </span>
                                                            </div> : <>
                                                                {item.qpOptions?.map((opt: any, i: number) => {
                                                                    return (
                                                                        <div className={`col-md-6 d-flex ${i % 2 == 0 ? 'ps-0' : 'pe-0'}`} key={i}>
                                                                            <div className={`p-2 w-100 mb-2 fs-15 ${opt.answer_option ? 'text-success fw-bold' : 'text-gray '}`}>
                                                                                <span className={`option-name fw-bold ${opt.answer_option ? 'text-success' : 'text-gray '}`}>
                                                                                    {String.fromCharCode(i + 65)}
                                                                                </span>
                                                                                <span className="ms-2 option"> {opt?.option_image ? <Image src={window.origin + "/api" + opt.option_image} height={50} /> : opt.optionText}</span>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}</>}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </>
                        )}
                    </div>
                    {/* <div className="text-center">
                        <Pagination defaultCurrent={pageIndex} current={pageIndex} total={totalRecord} defaultPageSize={pageSize} pageSize={pageSize}
                            onChange={handleChangePagination}
                            onShowSizeChange={handlePageSizeChange} showTotal={(total) => `Total ${count} items`} />
                    </div> */}
                </>
            </Modal>

        </div>
    );
};

export default BackupUpdateExam;
